export default function HttpCaching($httpProvider) {
    'ngInject';

    if (!$httpProvider.defaults.headers.common) {
        $httpProvider.defaults.headers.common = {};
    }

    //disable IE ajax request caching
    $httpProvider.defaults.headers.common['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    // extra
    $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.common.Pragma = 'no-cache';
}



// WEBPACK FOOTER //
// ./src/app/configs/httpCaching.config.js